export const kitHistoryOperationsTypes = [
	{ label: "Activation", value: 0 },
	{ label: "Deactivation", value: 1 },
	{ label: "Change Plan", value: 2 },
	{ label: "Alerts", value: 3 },
];
